import { ANALYTICS_EVENTS } from '@nandosaus/constants';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import { addThousandsSeparators } from '@nandosaus/state-management/lib/util/formatter';
import React from 'react';

import { analytics } from '../../../analytics';
import { Flex } from '../../grid';
import { Icon } from '../../icons';
import { Link } from '../../link';
import { navigation } from '../../../constants';
import { P } from '../../typography/new';
import { setLandingPage } from '../../../utils/auth';
import { useTheme } from '../../../hooks/useTheme';

const PointsRedemptionBanner = () => {
  const { MemberStore } = useRootStore();
  const { colors } = useTheme();

  const containerProps = {
    alignItems: 'center',
    backgroundColor: colors.warmWhite02,
    borderRadius: '13px',
    gap: '12px',
    px: '14px',
    py: '10px',
    height: 'fit-content',
  };

  if (!MemberStore.isSignedIn) {
    return (
      <Flex {...containerProps}>
        <Icon name="periPerksLogo" height="23px" width="30px" stroke="none" />
        <P variant="standard-semi-bold">
          <Link
            href={navigation.SIGN_IN}
            textDecoration="underline"
            variant="standard-semi-bold"
            onClick={() => {
              analytics.track(ANALYTICS_EVENTS.USER_SIGN_IN_CLICKED, { location: 'Menu Points Banner' });
              setLandingPage(navigation.MENU);
            }}
          >
            Sign in
          </Link>
          {' to redeem your PERi-Perks'}
        </P>
      </Flex>
    );
  }

  const { profile } = MemberStore;
  const dollarValue = profile.displayPointsInDollars;

  return (
    <Flex {...containerProps}>
      <Icon name="periPerksLogo" height="23px" width="30px" stroke="none" />
      <P variant="small-semi-bold">
        {"You've got "}
        <P as="span" variant="small-bold" color="customerRewards3">
          {`$${addThousandsSeparators(dollarValue)}`}
        </P>
        {' in points to use'}
      </P>
    </Flex>
  );
};

const ObservedPointsRedemptionBanner = observer(PointsRedemptionBanner);
export { ObservedPointsRedemptionBanner as PointsRedemptionBanner };
